export const trips = {
  1:"Camino Inka - Rutas 01, 02 y 03",
  4:"Camino Inka - Ruta 05",

  100:"Machupicchu - A partir de las 6:00",
  101:"Machupicchu - A partir de las 7:00",
  102:"Machupicchu - A partir de las 8:00",
  103:"Machupicchu - A partir de las 9:00",
  104:"Machupicchu - A partir de las 10:00",
  105:"Machupicchu - A partir de las 11:00",
  106:"Machupicchu - A partir de las 12:00",
  107:"Machupicchu - A partir de las 13:00",
  108:"Machupicchu - A partir de las 14:00",
  120:"Machupicchu con montaña Machupicchu - A partir de las 6:00",
  // 121:"Machupicchu con montaña Machupicchu - A partir de las 7:00",
  // 122:"Machupicchu con montaña Machupicchu - A partir de las 8:00",
  110:"Machupicchu con montaña Waynapicchu - A partir de las 6:00",

  111:"Circuito 4 + Montaña Waynapicchu 7:00 am",
  112:"Circuito 4 + Montaña Waynapicchu 8:00 am",
  113:"Circuito 4 + Montaña Waynapicchu 9:00 am",
  114:"Circuito 4 + Montaña Waynapicchu 10:00 am",

  121:"Montaña Machupicchu + Circuito 3 7:00 am",
  122:"Montaña Machupicchu + Circuito 3 8:00 am",

  131:"Circuito 4 + Montaña Huchuypicchu 7:00 am",
  132:"Circuito 4 + Montaña Huchuypicchu 8:00 am",
  133:"Circuito 4 + Montaña Huchuypicchu 9:00 am",
  134:"Circuito 4 + Montaña Huchuypicchu 10:00 am",
  135:"Circuito 4 + Montaña Huchuypicchu 11:00 am",
  136:"Circuito 4 + Montaña Huchuypicchu 12:00 pm",

  141:"Circuito 1 o 2 + Puente Inka 7:00 am",
  142:"Circuito 1 o 2 + Puente Inka 8:00 am",
  143:"Circuito 1 o 2 + Puente Inka 9:00 am",
  144:"Circuito 1 o 2 + Puente Inka 10:00 am",
  145:"Circuito 1 o 2 + Puente Inka 11:00 am",
  146:"Circuito 1 o 2 + Puente Inka 12:00 pm",
  147:"Circuito 1 o 2 + Puente Inka 1:00 pm",
  148:"Circuito 1 o 2 + Puente Inka 2:00 pm"
};

export let months_es = {
  0: 'Enero',
  1: 'Febrero',
  2: 'Marzo',
  3: 'Abril',
  4: 'Mayo',
  5: 'Junio',
  6: 'Julio',
  7: 'Agosto',
  8: 'Setiembre',
  9: 'Octubre',
  10: 'Noviembre',
  11: 'Diciembre'
};

export let months_en = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December'
};
